var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('LineGraph',{staticClass:"pa-3",attrs:{"chartdata":_vm.dataCollection,"y-label":_vm.yAxisLabel}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }